import {
    ApiClientSettings,
    buildLocalFontFaceCss,
    getLocalFontFamiliesFromSettings,
} from '@storefronts/common-types'
import Head from 'next/head'
import { useContext, useMemo } from 'react'
import { CustomizationContext } from '../context/customizationContext'

const getLocalFontFaceCssFromSettings = (
    settings: ApiClientSettings,
): string => {
    const families = getLocalFontFamiliesFromSettings(settings)
    if (families.length === 0) {
        return ''
    }

    return buildLocalFontFaceCss(families)
}

const getLocalFontPreloadUrls = (settings: ApiClientSettings): string[] => {
    const urls = new Set<string>()

    for (const family of getLocalFontFamiliesFromSettings(settings)) {
        for (const file of family.files) {
            if (file.type === 'LOCAL' && file.src) {
                urls.add(file.src)
            }
        }
    }

    return [...urls]
}

export const LocalFontLoader: React.FC = () => {
    const customization = useContext(CustomizationContext)
    const localFontCss = useMemo(
        () => getLocalFontFaceCssFromSettings(customization),
        [customization],
    )
    const preloadUrls = useMemo(
        () => getLocalFontPreloadUrls(customization),
        [customization],
    )

    if (!localFontCss) {
        return null
    }

    return (
        <Head>
            {preloadUrls.map((url) => (
                <link
                    key={url}
                    rel="preload"
                    href={url}
                    as="font"
                    type="font/woff2"
                    crossOrigin="anonymous"
                />
            ))}
            <style>{localFontCss}</style>
        </Head>
    )
}
